import React from "react";

const PageNotFound = () => {
    return <h1>Página inválida</h1>
}

export default PageNotFound;